module.exports = __webpack_public_path__ + "static/media/icon_arrow_answer.b00650e8.svg";